const VersionForm = ({ form, setForm }) => {
  return (
    <div className="grid gap-3">
      <div>
        <label className="block mb-1 font-semibold">Platform Name</label>
        <input
          type="text"
          value={form?.platform}
          onChange={(e) => setForm({ ...form, platform: e.target.value })}
          className="w-full border rounded-lg px-3 py-2"
          placeholder="platform name"
        />
      </div>

      <div>
        <label className="block mb-1 font-semibold">Version</label>
        <input
          type="text"
          value={form?.version}
          onChange={(e) => setForm({ ...form, version: e.target.value })}
          className="w-full border rounded-lg px-3 py-2"
          placeholder="3.3.9"
        />
      </div>
    </div>
  );
};

export default VersionForm;
